// ── 급여 관리 엔트리 포인트 ───────────────────────────────────────────────────
// 탭 방식으로 설정·직원 급여 정보·월 급여 관리 등을 전환합니다.
// Phase 1: 설정(회사설정 + 항목 + 보험요율 + 소득세) + 직원 급여 정보

import React, { useState, useEffect } from 'react';
import PayrollSettings from './payrollmanagement/PayrollSettings';
import PayrollEmployees from './payrollmanagement/PayrollEmployees';
import PayrollMonthly from './payrollmanagement/PayrollMonthly';
import PayrollMonthlyNotes from './payrollmanagement/PayrollMonthlyNotes';
import ConfidentialLockGate from './confidential/ConfidentialLockGate';
import {
  stdHeaderRow, stdPageTitle, stdPageSubtitle, stdTabGroup, stdTabBtn,
} from './adminlayout/designStandard';

const TABS = [
  { key: 'settings',  label: '급여 설정' },
  { key: 'employees', label: '직원 급여 정보' },
  { key: 'monthly',  label: '월 급여 관리' },
  { key: 'monthly_notes', label: '월 비고' },
];

export default function PayrollManagement({ companyCode }) {
  const [tab, setTab] = useState('settings');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // 대외비 비밀번호(2026-10-16) — 걸린 회사는 비밀번호를 넣어야 이 화면이 보인다(탭 부품이 자료를 부르므로 안에서 감싸도 된다)
  return (
    <ConfidentialLockGate companyCode={companyCode} menuName="급여 관리" menuKey="payroll">
    <div>
      {/* ── 페이지 헤더: 제목/부제(좌) + 탭(우) — 직원 관리 표준 ── */}
      <div style={stdHeaderRow(isMobile)}>
        <div>
          {/* 제목에 회사코드를 붙이지 않는다 (2026-09-11) — 어느 회사인지는 상단 선택창이 알려준다.
              미팅링크 운영자에게 "급여 관리 PINE" 으로 보이던 자리다. PINE 은 코드 안에서
              "본사" 라는 뜻으로 쓰이는 말이라 화면에 그대로 내보낼 값이 아니다. */}
          <h2 style={stdPageTitle}>급여 관리</h2>
          <div style={stdPageSubtitle}>월별 급여 계산·확정을 관리합니다.</div>
        </div>
        <div style={stdTabGroup}>
          {TABS.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} style={stdTabBtn(tab === t.key)}>
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* 탭 콘텐츠 */}
      {tab === 'settings'  && <PayrollSettings companyCode={companyCode} />}
      {tab === 'employees' && <PayrollEmployees companyCode={companyCode} />}
      {tab === 'monthly'  && <PayrollMonthly companyCode={companyCode} />}
      {tab === 'monthly_notes' && <PayrollMonthlyNotes companyCode={companyCode} />}
    </div>
    </ConfidentialLockGate>
  );
}
